import { memo } from 'react';
import type { CapitalGlobalSelectOption } from '@/features/quotes/schemas/capital-global/coverages-catalog';
import { CapitalGlobalClearableSelect } from './capital-global-clearable-select.component';

/* eslint-disable no-unused-vars -- callback parameter names document arity for callers */
type Props = {
  value: string;
  onValueChange: (next: string) => void;
  disabled?: boolean;
  required?: boolean;
  error?: string;
  /** API-driven list when available; defaults to central mock. */
  items?: CapitalGlobalSelectOption[];
};
/* eslint-enable no-unused-vars */

/**
 * Funeral assistance select below toggles (Figma Step 3). Memoized like CapitalizationSelectSection.
 */
export const AssistanceFuneralSelectSection = memo(
  function AssistanceFuneralSelectSection({
    value,
    onValueChange,
    disabled,
    required = false,
    error,
    items = [],
  }: Props) {
    return (
      <div className='flex w-full flex-col gap-2'>
        <CapitalGlobalClearableSelect
          label='Assistência Funeral'
          value={value}
          onValueChange={onValueChange}
          placeholder='Selecione a assistência'
          disabled={disabled}
          required={required}
          error={error}
          items={items}
        />
      </div>
    );
  }
);
